module.exports = __webpack_public_path__ + "static/media/Test8.a1bd512a.bmp";